import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgSelectModule } from "@ng-select/ng-select";
import { I18nModule } from "@spartacus/core";
import { ConfirmProfilePopupComponent } from "./confirm-profile-popup/confirm-profile-popup.component";


@NgModule({
  declarations: [ConfirmProfilePopupComponent],
  exports:[
    ConfirmProfilePopupComponent
      ],
  imports: [
    CommonModule,
    NgSelectModule,
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    I18nModule
  ],
  providers: [
  ]
})
export class ConfirmProfilePopupModule { }
